import { RowValue } from './row-value.model'

export class Row {
  id: string;
  isOpen: boolean;
  name: string;
  value: RowValue[] = [];
}
